import * as React from 'react';
import { styles } from './styles';
import { cx } from 'emotion';

interface Props {
  className?: string;
  children: React.ReactNode;
}

export const DesignBucketContent: React.SFC<Props> = ({ children, className }) => {
  return <div className={cx(styles.container, className)}>{children}</div>;
};
